import { render, staticRenderFns } from "./LocksAnalysisTool.vue?vue&type=template&id=52075428&scoped=true&"
import script from "./LocksAnalysisTool.vue?vue&type=script&lang=js&"
export * from "./LocksAnalysisTool.vue?vue&type=script&lang=js&"
import style0 from "./LocksAnalysisTool.vue?vue&type=style&index=0&id=52075428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52075428",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VCol,VIcon,VList,VListItem,VListItemAction,VListItemContent,VRow,VSpacer,VTooltip})
